import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))
const Show = React.lazy(() => import('./Show'))

export default {
  path: '/:channel/modules',
  name: 'Modules',
  component: Layout,
  protected: true,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'show', name: 'Show', component: Show },
  ],
};



// WEBPACK FOOTER //
// ./src/features/modules/route.js